import { Newsroom } from "./Newsroom.js";
export let Story;
(function (_Story) {
  let FormatVersion = /*#__PURE__*/function (FormatVersion) {
    FormatVersion[FormatVersion["HTML"] = 1] = "HTML";
    FormatVersion[FormatVersion["SLATEJS_V3"] = 3] = "SLATEJS_V3";
    FormatVersion[FormatVersion["SLATEJS_V4"] = 4] = "SLATEJS_V4";
    FormatVersion[FormatVersion["SLATEJS_V5"] = 5] = "SLATEJS_V5";
    FormatVersion[FormatVersion["SLATEJS_V6"] = 6] = "SLATEJS_V6";
    return FormatVersion;
  }({});
  _Story.FormatVersion = FormatVersion;
  let Status = /*#__PURE__*/function (Status) {
    Status["UNINITIALIZED"] = "uninitialized";
    Status["DRAFT"] = "draft";
    Status["SCHEDULED"] = "scheduled";
    Status["EMBARGO"] = "embargo";
    Status["PUBLISHED"] = "published";
    return Status;
  }({});
  _Story.Status = Status;
  const LifecycleStatus = _Story.LifecycleStatus = Status;
  /**
   * @deprecated Please use `Status` instead.
   * @see Status
   */
  let PublicationStatus = /*#__PURE__*/function (PublicationStatus) {
    PublicationStatus["NEW"] = "new";
    PublicationStatus["DRAFT"] = "draft";
    PublicationStatus["PUBLISHED"] = "published";
    return PublicationStatus;
  }({});
  _Story.PublicationStatus = PublicationStatus;
  let Visibility = /*#__PURE__*/function (Visibility) {
    Visibility["PUBLIC"] = "public";
    Visibility["EMBARGO"] = "embargo";
    Visibility["PRIVATE"] = "private";
    Visibility["CONFIDENTIAL"] = "confidential";
    return Visibility;
  }({});
  _Story.Visibility = Visibility;
  /*
   * Newsroom status checks
   */

  function isActiveNewsroom(story) {
    return Newsroom.isActive(story.newsroom);
  }
  _Story.isActiveNewsroom = isActiveNewsroom;
  function isInactiveNewsroom(story) {
    return Newsroom.isInactive(story.newsroom);
  }
  _Story.isInactiveNewsroom = isInactiveNewsroom;
  function isArchivedNewsroom(story) {
    return Newsroom.isArchived(story.newsroom);
  }
  _Story.isArchivedNewsroom = isArchivedNewsroom;
  /*
   * Lifecycle status checks
   */
  function isUninitialized(arg) {
    if (typeof arg === 'object' && arg !== null) {
      return isUninitialized(arg.status);
    }
    return arg === Status.UNINITIALIZED;
  }
  _Story.isUninitialized = isUninitialized;
  function isDraft(arg) {
    if (typeof arg === 'object' && arg !== null) {
      return isDraft(arg.status);
    }
    return arg === Status.DRAFT;
  }
  _Story.isDraft = isDraft;
  function isUninitializedOrDraft(arg) {
    if (typeof arg === 'object' && arg !== null) {
      return isUninitializedOrDraft(arg.status);
    }
    return arg === Status.UNINITIALIZED || arg === Status.DRAFT;
  }
  _Story.isUninitializedOrDraft = isUninitializedOrDraft;
  function isScheduled(arg) {
    if (typeof arg === 'object' && arg !== null) {
      return isScheduled(arg.status);
    }
    return arg === Status.SCHEDULED;
  }
  _Story.isScheduled = isScheduled;
  function isScheduledEmbargo(arg) {
    if (typeof arg === 'object' && arg !== null) {
      return isScheduledEmbargo(arg.status);
    }
    return arg === Status.EMBARGO;
  }
  _Story.isScheduledEmbargo = isScheduledEmbargo;
  function isPublished(arg) {
    if (typeof arg === 'object' && arg !== null) {
      return isPublished(arg.status);
    }
    return arg === Status.PUBLISHED;
  }
  _Story.isPublished = isPublished;
  /*
   * Format version checks
   */
  function isLegacyHtmlFormat(arg) {
    if (typeof arg === 'object' && arg !== null) {
      return isLegacyHtmlFormat(arg.format_version);
    }
    return arg === FormatVersion.HTML;
  }
  _Story.isLegacyHtmlFormat = isLegacyHtmlFormat;
  function isSlateFormat(arg) {
    if (typeof arg === 'object' && arg !== null) {
      return isSlateFormat(arg.format_version);
    }
    return arg === FormatVersion.SLATEJS_V3 || arg === FormatVersion.SLATEJS_V4 || arg === FormatVersion.SLATEJS_V5 || arg === FormatVersion.SLATEJS_V6;
  }
  _Story.isSlateFormat = isSlateFormat;
  function isSlateV3Format(arg) {
    if (typeof arg === 'object' && arg !== null) {
      return arg.format_version === FormatVersion.SLATEJS_V3;
    }
    return arg === FormatVersion.SLATEJS_V3;
  }
  _Story.isSlateV3Format = isSlateV3Format;
  function isSlateV4Format(arg) {
    if (typeof arg === 'object' && arg !== null) {
      return arg.format_version === FormatVersion.SLATEJS_V4;
    }
    return arg === FormatVersion.SLATEJS_V4;
  }
  _Story.isSlateV4Format = isSlateV4Format;
  function isSlateV5Format(arg) {
    if (typeof arg === 'object' && arg !== null) {
      return arg.format_version === FormatVersion.SLATEJS_V5;
    }
    return arg === FormatVersion.SLATEJS_V5;
  }
  _Story.isSlateV5Format = isSlateV5Format;
  function isSlateV6Format(arg) {
    if (typeof arg === 'object' && arg !== null) {
      return arg.format_version === FormatVersion.SLATEJS_V6;
    }
    return arg === FormatVersion.SLATEJS_V6;
  }
  _Story.isSlateV6Format = isSlateV6Format;
})(Story || (Story = {}));